//@ts-strict-ignore
import React from 'react';
import PrintCustomerStatementMutation from 'graphql/mutations/customer/PrintStatementRange.graphql';
import CustomerStatementWorkspaceQuery from 'graphql/queries/customer/CustomerStatementWorkspaceQuery.graphql';

import hasValidationErrors from '../../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from '../../../utils/BackgroundJobs';
import { onDocumentComplete, onDocumentPrintFailed } from '../../../utils/DocumentUtils';
import { EntityType } from '../../../@types/entityTypes';
import { IWorkspaceAction } from '../../../@types/workspaceTypes';
import { ReportType } from '../../schema/p4types';

const PrintStatementAction = React.lazy(
  () => import('../../../components/ActionButtons/customers/PrintStatementAction')
);

function onComplete(state, props, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Statement',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
}

//Third argument is just for compatibility with other document 'generateRange' functions.
//Statements uses the passed rangeMutationProps.
function generateRange(state, props, _, returnUrl, { rangeMutationProps }) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    PrintCustomerStatementMutation,
    rangeMutationProps,
    props,
    returnUrl,
    'Print Statements',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

const customerStatementWorkspaceActions: Array<IWorkspaceAction> = [
  {
    description: 'Generate Statement',
    element: <PrintStatementAction />,
    actionReference: 'GENERATE_STATEMENT',
  },
];

const CustomerStatement: EntityType = {
  type: 'AgedDebtReport',
  title: 'Customer Statement',
  printFunctions: { generateRange },
  screenReference: 'SALES_DOCUMENTS_PRINT_STATEMENTS',
  workspace: CustomerStatementWorkspaceQuery,
  workspaceUrl: '/Customers/CustomerStatements/Workspace/',
  actions: customerStatementWorkspaceActions,
  configuration: {
    title: 'Customer Statements',
    field: 'statementDocumentDefault',
    reportType: ReportType.CustomerStatementReport,
    customerField: 'customerStatementDocumentDefault',
    receiveFlag: 'receiveStatementDocuments',
  },
  operations: 0,
};

export default CustomerStatement;
